import { useAuthStore } from '../stores/auth'

export function useImageAuthentication(shared, linkId, hmac, authenticatedPassword) {
  const authStore = useAuthStore()

  const getAuthenticatedImageUrl = (baseImageUrl) => {
    if (!baseImageUrl) return ''

    let imageUrl = baseImageUrl

    // For shared links, append authentication parameters to image URL
    if (shared.value && linkId.value && hmac.value) {
      const urlParams = new URLSearchParams()
      urlParams.append('link_id', linkId.value)
      urlParams.append('hmac', hmac.value)
      if (authenticatedPassword.value) {
        urlParams.append('password', authenticatedPassword.value)
      }
      imageUrl = `${baseImageUrl}?${urlParams.toString()}`
    } else {
      // For authenticated users, ensure we include auth token
      if (authStore.token) {
        const urlParams = new URLSearchParams()
        urlParams.append('token', authStore.token)
        const separator = imageUrl.includes('?') ? '&' : '?'
        imageUrl = `${imageUrl}${separator}${urlParams.toString()}`
      }
    }

    return imageUrl
  }

  const getGroupImageStyle = (groupData) => {
    if (groupData?.image_url) {
      const imageUrl = getAuthenticatedImageUrl(groupData.image_url)

      const style = {
        backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url(${imageUrl})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }
      return style
    }
    return {}
  }

  return {
    getAuthenticatedImageUrl,
    getGroupImageStyle
  }
}